/**
 * VendorPaymentService
 * Service for managing vendor payment information
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor payment CRUD operations with vendor-specific queries
 */
export class VendorPaymentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPaymentService.DEFAULT_SERVICE_PATH,
            basePath: VendorPaymentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all payment records for a specific vendor
     * @param vendorId - The vendor ID
     * @returns Array of vendor payment views
     */
    async getByVendor(vendorId) {
        const response = await this.getByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all payment records for a specific vendor with full response
     * @param vendorId - The vendor ID
     * @returns ResponseData with array of vendor payment views
     */
    getByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}`);
        return this.http.get(url);
    }
    // ==================== MODEL VIEW QUERIES ====================
    /**
     * Get all vendor payments as model views
     * @returns Array of vendor payment model views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all vendor payments as model views with full response
     * @returns ResponseData with array of vendor payment model views
     */
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get vendor payment model view by ID
     * @param id - Payment ID
     * @returns The vendor payment model view
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`VendorPayment view not found: id=${id}`);
        }
        return response.data;
    }
    /**
     * Get vendor payment model view by ID with full response
     * @param id - Payment ID
     * @returns ResponseData with vendor payment model view
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
    /**
     * Get all payment model views for a specific vendor
     * @param vendorId - Vendor ID
     * @returns Array of vendor payment model views
     */
    async getViewsByVendor(vendorId) {
        const response = await this.getViewsByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all payment model views for a specific vendor with full response
     * @param vendorId - Vendor ID
     * @returns ResponseData with array of vendor payment model views
     */
    getViewsByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}/views`);
        return this.http.get(url);
    }
}
VendorPaymentService.DEFAULT_SERVICE_PATH = 'vendors';
VendorPaymentService.BASE_PATH = 'api/vendor-payments';
//# sourceMappingURL=VendorPaymentService.js.map